import * as React from 'react';

// icons
import 'font-awesome/css/font-awesome.min.css';

// styling
import 'bootstrap/dist/css/bootstrap.min.css';

// toast
import 'react-toastify/dist/ReactToastify.css';


// services
import {createItemGen, currentBaseUrl, currentUser, currentUserId, deleteItemGen, getGeneralSmartTableData, isUserLoggedIn, updateItemGen, getGeneralDirect} from '../../common/services';

// contants
import {MEDIABASE, initialState} from '../../common/constants';

// components
import Loader from 'react-loader'
import NavBar from '../../components/CustomNav/CustomNav.Component';

// loader
import SimpleLoader from '../../common/simpleLoader.Component';

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer} from 'react-toastify';

// reactstrap
// import {Col, Row } from 'reactstrap';
import SmartDataTable from 'react-smart-data-table'

// html parser server
import ReactDOMServer from 'react-dom/server';

// tabs
import {Breadcrumb, BreadcrumbItem,
        Button,ButtonDropdown, Card,
        CardBody, CardHeader,Col, DropdownItem,
        DropdownMenu, DropdownToggle, Form, FormGroup,
        Input, InputGroup, InputGroupAddon, Label, Modal,
        ModalBody, ModalFooter, ModalHeader, Nav, NavItem,
        NavLink, Pagination, PaginationItem, PaginationLink,
        Row, TabContent, Table, TabPane} from 'reactstrap';


import {EditorState, convertToRaw, convertFromRaw} from 'draft-js';

// draglist
import ReactDragList from 'react-drag-list';
import 'react-drag-list/assets/index.css';

import { TwitterPicker } from 'react-color';

import { render } from 'react-dom';

import Gallery from 'react-grid-gallery';

import { Scrollbars } from 'react-custom-scrollbars';

// utils
import {processDrag, processRedWords} from '../../common/utils';

// editor
import CustomDocEditor from '../../common/documentEditor';

// interactions
import RecallInteraction from '../../components/RecallInteraction/RecallInteraction.Component';
import DragDropInteraction from '../../components/DnDInteraction/DragDropInteraction.Component';
import MultipleChoiceInteraction from '../../components/MultipleChoiceInteraction/MultipleChoiceInteraction.Component';
import MultipleChoiceMultiInteraction from '../../components/MultipleChoiceMultiInteraction/MultipleChoiceMultiInteraction.Component';

class LessonScreenPage extends React.Component {
    public state = {
      activeTab: '1',
      answereditmodal: false,
      answermodal: false,
      answers: [],
      assessments: [],
      assetfields: {
        filename: 'FileName',
        id: 'id',
        title: 'Title'
        },
      assets: [],
      baseurl: currentBaseUrl(),
      behaviour_feedback: [],
      behaviours: [],
      codemodal: false,
      contentscreenid: 0,
      codecontentcreatemodal: false,
      contentcreatemodal: false,
      contentpreviewmodal: false,
      currentinteractiondata: {} as any,
      currentscreenbackground: '#0693e3',
      currentscreencolor: "#0000",
      currentscreenfont: "Open Sans",
      currentscreenidx: 0,
      currenttimeout: {} as any,
      destination: '',
      interactionsetdata: {} as any,
      interactionmodal: false,
      formats : [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'color', 'font', 'size', 'list'
      ],
      htmltext: '',
      icons: [],
      imageimportmodal: false,
      images: [] as any[],
      interactionfields: {
        id: 'id',
        title: 'Title'
        },
      interactionsets: [] as any[],
      lessoninfo: {} as any,
      loaded: false,
      modules:{
        toolbar: {
            container: "#toolbar",
            handlers: {
                "insertImage": this.insertImage,
            }
        },
        imageResize: {
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
            handleStyles: {
                backgroundColor: 'black',
                border: 'none',
                color: 'white'
            }
        }
       } ,
      mounted: false,
      navigate: false,
      processingmodal: false,
      question_groups: [],
      questionmodal: false,
      questions: [],
      questionstep: 0,
      screenfields: {
        id: 'id',
        title: 'Title',
        order: 'DisplayOrder',
        type: 'ScreenType',
        videourl: 'VideoUrl',
      },
      screens: [] as any,
      tologin: false,
      username: '',
      videocreatemodal: false,
    }

    public quillref: React.RefObject<{}>;

    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
        this.setTab = this.setTab.bind(this);
        this.contentcreatetoggle = this.contentcreatetoggle.bind(this);
        this.codecontentcreatetoggle = this.codecontentcreatetoggle.bind(this);
        this.questiontoggle = this.questiontoggle.bind(this);
        this.answertoggle = this.answertoggle.bind(this);
        this.videocreatetoggle = this.videocreatetoggle.bind(this);
        this.answeredittoggle = this.answeredittoggle.bind(this);
        this.interactiontoggle = this.interactiontoggle.bind(this);
        this.InteractioncreateSubmit = this.InteractioncreateSubmit.bind(this);

        this.orderSubmit = this.orderSubmit.bind(this);

        this.codecontentcreateSubmit = this.codecontentcreateSubmit.bind(this);

        this.handleDeleteClicked = this.handleDeleteClicked.bind(this);
        this.handleEditAnswerClicked = this.handleEditAnswerClicked.bind(this);

        this.loadScreenEditor = this.loadScreenEditor.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);

        this.contentpreviewtoggle = this.contentpreviewtoggle.bind(this);
        this.codetoggle = this.codetoggle.bind(this);
        this.imageimporttoggle = this.imageimporttoggle.bind(this);
        this.insertImage = this.insertImage.bind(this);
        this.handleAssetsLoaded = this.handleAssetsLoaded.bind(this);

        this.handleBackgroundChange = this.handleBackgroundChange.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.handleFontChange = this.handleFontChange.bind(this);

        this.insertChosenImage = this.insertChosenImage.bind(this);

        this.quillref = React.createRef();

        this.handleOrderUpdate = this.handleOrderUpdate.bind(this);
        this.handleInteractionSetloaded = this.handleInteractionSetloaded.bind(this);
        this.handleInteractionloaded = this.handleInteractionloaded.bind(this);

        this.getRandomArbitrary = this.getRandomArbitrary.bind(this);
        this.interactionComplete = this.interactionComplete.bind(this);

        this.onEditorChange = this.onEditorChange.bind(this);

        this.handleGenScreensLoaded = this.handleGenScreensLoaded.bind(this);

        this.setScreenId = this.setScreenId.bind(this);

        this.gotoPreview = this.gotoPreview.bind(this);
    }


    public onEditorChange = (editorState) => {
        this.setState({
          editorState,
        });
    };

    public gotoPreview () {
        this.setState({navigate: true, destination: currentBaseUrl() + 'lessonpreview/' + this.currentid()})
    }

    public insertImage (evt) {
        // const cursorPosition = this.quill.getSelection().index
        // this.quill.insertText(cursorPosition, "★")
        // this.quill.setSelection(cursorPosition + 1)
        console.log('inserting image')
        console.log(evt)
        // this.imageimporttoggle()
      }

    public handleBackgroundChange(color, event) {
        this.setState({currentscreenbackground: color.hex});
    }

    public handleColorChange(color, event) {
        this.setState({currentscreencolor: color.hex});
    }

    public handleFontChange(nextFont, event) {
        console.log(nextFont)
        this.setState({currentscreenfont: nextFont.family});
    }

    public insertChosenImage(link, evt) {

        console.log(link)

        const node = this.quillref.current as any;

        if (node.state.selection !== null) {
            const cursorPosition = node.state.selection.index
            console.log(cursorPosition)

            node.editor.insertEmbed(cursorPosition, 'image', link);

            node.editor.setSelection(cursorPosition + 1);
        }

        this.setState({
            imageimportmodal: !this.state.imageimportmodal,
          });

    }


    public contentcreatetoggle() {
        this.setState({
          contentcreatemodal: !this.state.contentcreatemodal,
        });
    }

    public codecontentcreatetoggle () {
        this.setState({
            codecontentcreatemodal: !this.state.codecontentcreatemodal,
          });
    }

    public codetoggle() {
        this.setState({
          codemodal: !this.state.codemodal,
        });
    }

    public imageimporttoggle() {
        const node = this.quillref.current as any;

        if (node.state.selection !== null) {
            const crs = node.state.selection.index
            console.log(crs)
        }

        console.log(node)

        this.setState({
          imageimportmodal: !this.state.imageimportmodal,
        });
    }

    public contentpreviewtoggle() {
        this.setState({
          contentpreviewmodal: !this.state.contentpreviewmodal,
        });
    }

    public questiontoggle() {
        this.setState({
          questionmodal: !this.state.questionmodal,
        });
    }

    public answertoggle() {
        this.setState({
          answermodal: !this.state.answermodal,
        });
    }

    public answeredittoggle() {
        this.setState({
          answereditmodal: !this.state.answereditmodal,
        });
    }

    public videocreatetoggle() {
        this.setState({
          videocreatemodal: !this.state.videocreatemodal,
        });
    }

    public interactiontoggle() {
        this.setState({
            interactionmodal: !this.state.interactionmodal,
        });
    }

    public onLogout(arg) {
        console.log('Logout in Parent', arg);
        this.setState({tologin: true});
    }

    public videocreateSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})

        const item = {
            DisplayData: null,
            DisplayOrder: event.target.elements.order.value,
            Title: event.target.elements.title.value,
            Lesson: this.currentid(),
            ScreenType: 2,
            User: currentUserId(),
            VideoUrl: event.target.elements.video.value,
        }

        console.log(item);

        createItemGen( 'admin/lesson_screens/', item, text => this.handleGenCreatedItemLoaded('admin/lesson_screens/by_lesson/?id=' + this.currentid(), 'screens', 'screens',text));
    }

    public InteractioncreateSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})

        const item = {
            DisplayData: null,
            DisplayOrder: event.target.elements.order.value,
            InteractionSet: event.target.elements.interactionset.value,
            Title: event.target.elements.title.value,
            Lesson: this.currentid(),
            ScreenType: 1,
            User: currentUserId(),
            VideoUrl: null,
        }

        console.log(item);

        createItemGen( 'admin/lesson_screens/', item, text => this.handleGenCreatedItemLoaded('admin/lesson_screens/by_lesson/?id=' + this.currentid(), 'screens', 'screens',text));
    }


    public codecontentcreateSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})

        const dispord = event.target.elements.order.value;

        const tit = event.target.elements.title.value;

        const fileInputElement = event.target.elements.code;

        const actualfile = fileInputElement.files[0]

        const fileReader = new FileReader();
        fileReader.onload = (fileLoadedEvent) =>{
            const ky = 'result'
            const tgt = fileLoadedEvent.target![ky] as any;
            if (tgt) {
                // htmltxt = tgt.result;
                console.log('file has been read');
                const htmlobject = {
                    html: tgt,
                    background: this.state.currentscreenbackground,
                    color: this.state.currentscreencolor,
                    font: this.state.currentscreenfont
                }

                const item = {
                    DisplayData: JSON.stringify(htmlobject),
                    DisplayOrder: dispord ,
                    Title: tit,
                    Lesson: this.currentid(),
                    ScreenType: 0,
                    User: currentUserId(),
                    VideoUrl: ''
                }

                console.log(item);

                createItemGen( 'admin/lesson_screens/', item, text => this.handleGenCreatedItemLoaded('admin/lesson_screens/by_lesson/?id=' + this.currentid(), 'screens', 'screens',text));
            }
        };

        fileReader.readAsText(actualfile, "UTF-8");
      }


    public contentcreateSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})

        const htmlobject = {
            // html: '<p> Default Content </p>', // stateToHTML(EditorState.createWithContent(convertFromRaw(initialState as any)) as any),
            // draft: initialState,
            background: this.state.currentscreenbackground,
            color: '#0693E3',
            font: '#000000'
        }

        const item = {
            DisplayData: JSON.stringify(htmlobject),
            DisplayOrder: event.target.elements.order.value,
            Title: event.target.elements.title.value,
            Lesson: this.currentid(),
            ScreenType: 0,
            User: currentUserId(),
            VideoUrl: ''
        }

        console.log(item);

        createItemGen( 'admin/lesson_screens/', item, text => this.handleGenCreatedItemLoaded('admin/lesson_screens/by_lesson/?id=' + this.currentid(), 'screens', 'screens',text));
      }

      public handleOrderSubmitted (res) {
        console.log(res);
        if(res.code ===200){
            getGeneralSmartTableData( 'admin/lesson_screens/by_lesson/?id=' + this.currentid(), text => this.handleGenScreensLoaded(text));
        }

      }

      public orderSubmit = (event) => {
        // event.preventDefault()
        this.setState({processingmodal: true})

        const tempscr = [] as any[]

        const allscreens = this.state.screens

        let count = this.state.screens.length

        for (const screen of this.state.screens) {
            tempscr.push({id: screen.id, order: count, Title: screen.Title})
            count -= 1
        }

        const item = {
            DisplayItems: JSON.stringify(tempscr),
        }

        console.log(item);

        createItemGen( 'admin/lesson_screens/update_order/', item, text => this.handleOrderSubmitted(text));
      }


      public handleGenSmartDataLoaded(key,objkey, res) {
        if(res.code ===200){
            console.log(key);
            this.setState({loaded: true});
            this.setState({[key]: res.response[objkey]});
            // this.setState({htmltext: currentscreen[keydisplaydata].html});
            this.loadScreenEditor();

        }
        if(res.code ===401){
            this.onLogout('arg');
        }
    }

    public handleGenScreensLoaded(res) {
        if(res.code ===200){
            const tabledata = [] as any[];

            for (const row of res.response.screens) {
                tabledata.push(
                    {
                        id: row.id,
                        Title: row.Title,
                        ScreenType: row.ScreenType === 0?'Content':row.ScreenType === 1?'Interaction':'Video',
                        DisplayOrder: row.DisplayOrder,
                        Created: row.Created,
                        Creator: row.Creator,
                        DisplayData: ''
                    }
                )
            }

            this.setState({screens: tabledata});
        }
        if(res.code ===401){
            this.onLogout('arg');
        }
    }

    public handleAssetsLoaded(objkey, res) {
        if(res.code ===200){
            console.log(objkey);

            const tempimages = [] as any[]

            for (const o of res.response[objkey]) {
                console.log(o)
                tempimages.push(
                    {
                        src: MEDIABASE + 'assets/' + o.FileName,
                        thumbnail: MEDIABASE + 'assets/' + o.FileName,
                        thumbnailWidth: 110,
                        thumbnailHeight: 100,
                        caption: o.Title
                    }
                )
            }
            this.setState({images: tempimages});

        }
        if(res.code ===401){
            this.onLogout('arg');
        }
    }


    public handleGenCreatedItemLoaded(fetchendpoint,refreshkey, arraykey, res) {
        if(res.code ===200){

            if(refreshkey === 'screens') {
                // setTimeout(this.contentcreatetoggle, 100);
                this.setState({contentcreatemodal: false, videocreatemodal: false, interactionmodal: false})
                getGeneralSmartTableData( fetchendpoint, text => this.handleGenScreensLoaded(text));
            }

            else {
                getGeneralSmartTableData( fetchendpoint, text => this.handleGenSmartDataLoaded(refreshkey, arraykey,text));
            }

            this.setState({processingmodal: false});
        }
        if(res.code ===404){
            toast('Request failed, try again');
            this.setState({processingmodal: false});
        }
        if(res.code ===401){
            toast('Request unauthorized');
            this.onLogout('arg');
        }
    }


    public setTab(param, e) {
        this.setState({
        activeTab: param
         });
    }

    public handleOrderUpdate = (evt, updated) => {
        // console.log(evt); // tslint:disable-line
        console.log(updated); // tslint:disable-line
        this.setState({screens: updated})
        // this.state.screens = updated;
        // this.forceUpdate();
    }


    public openWidget(param, e) {
        console.log('widget: ' + param)
        this.setState({destination: currentBaseUrl() + param})
        this.setState({navigate: true})
    }

    public setScreenId(row) {
        this.setState({contentscreenid: row.id});

    }

    public handleDeleteClicked(row) {
        const retVal = confirm("Do you want to continue ?");
        if(retVal === true) {
                  console.log('delete accepted');
                  deleteItemGen( 'admin/lesson_screens/' + row.id + '/', text => this.handleGenCreatedItemLoaded('admin/lesson_screens/by_lesson/?id=' + this.currentid(), 'screens', 'screens',text));
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public handleEditAnswerClicked(idx, e) {
        console.log('idx', idx);
        this.setState({currentquestionidx: idx});
        this.answeredittoggle();
    }

    public onRowClick(event, { rowData, rowIndex, tableData }) {
        const { title } = rowData;
        console.log(title);
    }

    public handleLessonInfoLoaded (res) {
        this.setState({lessoninfo: res.response})
    }

    public componentDidMount() {
        if(!isUserLoggedIn()){
            this.setState({ tologin: true });
          }
        else{
            this.setState({ username: currentUser()});
            getGeneralSmartTableData( 'admin/lesson_screens/by_lesson/?id=' + this.currentid(), text => this.handleGenScreensLoaded(text));
            getGeneralSmartTableData( 'admin/assets/video_items/', text => this.handleGenSmartDataLoaded('assets', 'assets',text));
            getGeneralSmartTableData( 'admin/assets/overview_items/', text => this.handleAssetsLoaded('assets',text));
            getGeneralSmartTableData( 'admin/lessons/' + this.currentid() + '/', text => this.handleLessonInfoLoaded(text));
            getGeneralSmartTableData( 'admin/interaction_sets/list_items/', text => this.handleGenSmartDataLoaded('interactionsets', 'interaction_sets',text));
        }


        this.setState({ mounted: true});
        console.log(this.currentid());
    }

    public currentid (){
        const key1 = 'match';
        return this.props[key1].params.id
    }

    public interactionComplete () {
        console.log('complete');
    }


    public showInteraction () {
        if (this.state.currentinteractiondata === {}) {
            return (
                <p>No Interaction Data</p>
            )
        }
        else {
            if(this.state.currentinteractiondata.interaction_type === 'choice') {
                if(this.state.currentinteractiondata.choice_type === 'single_choice') {
                    return (
                        <MultipleChoiceInteraction oncomplete={this.interactionComplete} demomode={true} show={true} lessonid="1" interactionid="1"
                         completiontext={this.state.currentinteractiondata.completion_text} submittext={"Submit"}
                         introtext={this.state.currentinteractiondata.intro_text}
                         question={this.state.currentinteractiondata.question_text}
                         answers={this.state.currentinteractiondata.choice_answers} penalty={this.state.currentinteractiondata.penalty} timelimit={this.state.currentinteractiondata.time_limit}/>
                    );
                }
                else {
                    return (
                        <MultipleChoiceMultiInteraction oncomplete={this.interactionComplete} demomode={true} show={true} lessonid="1" interactionid="1"
                         completiontext={this.state.currentinteractiondata.completion_text} submittext={"Submit"}
                         introtext={this.state.currentinteractiondata.intro_text}
                         question={this.state.currentinteractiondata.question_text}
                         answers={this.state.currentinteractiondata.choice_answers} penalty={this.state.currentinteractiondata.penalty} timelimit={this.state.currentinteractiondata.time_limit}/>
                    );
                }
            }
            else if(this.state.currentinteractiondata.interaction_type === 'draganddrop') {
                return (
                    <DragDropInteraction oncomplete={this.interactionComplete} demomode={true} show={true} lessonid="1" interactionid="1" completiontext={this.state.currentinteractiondata.completion_text} submittext={"Submit"}
                     introtext={this.state.currentinteractiondata.intro_text}  dragquestions={processDrag(this.state.currentinteractiondata.options)}
                     penalty={this.state.currentinteractiondata.penalty} timelimit={this.state.currentinteractiondata.time_limit}/>
                );
            }
            else if(this.state.currentinteractiondata.interaction_type === 'recall') {
                return (
                    <RecallInteraction oncomplete={this.interactionComplete} demomode={true} show={true} lessonid="1" interactionid="1" completiontext={this.state.currentinteractiondata.completion_text} submittext={"Submit"}
                    introtext={this.state.currentinteractiondata.intro_text}  question={this.state.currentinteractiondata.paragraph_copy}
                    redwords={processRedWords(this.state.currentinteractiondata.recall_words)} penalty={this.state.currentinteractiondata.penalty} timelimit={this.state.currentinteractiondata.time_limit}/>
                );
            }

            return (
                <Loader/>
            )
        }
    }

    public handleInteractionloaded (res) {
        console.log(res);
        this.setState({processingmodal: false, currentinteractiondata: res.response})
    }

    public handleInteractionSetloaded (res) {
        console.log(res);
        const interactionsetdata = res.response as any;

        if (res.code !== 200) {
            return;
        }

        // pick first interaction in the set
        if (interactionsetdata.interactions.length > 0) {
            const randomint = this.getRandomArbitrary(0, interactionsetdata.interactions.length -1)

            console.log(randomint);

            getGeneralDirect( interactionsetdata.interactions[randomint].url, text => this.handleInteractionloaded(text));

            this.setState({interactionsetdata: res.response});
        }
        else {
            toast('No interactions found on this screen');
        }

    }

    public getRandomArbitrary(min, max) {
        return Math.round(Math.random() * (max - min) + min);
    }

    public loadScreenEditor(){

        const keyscreentype = 'ScreenType'
        const keyvideourl = 'VideoUrl'
        const keydisplaydata = 'DisplayData'
        const keyinteractionset = 'InteractionSet'

        const currentscreen = this.state.screens[this.state.currentscreenidx]

        if(currentscreen[keyscreentype] === 0) {
            this.setState({htmltext: currentscreen[keydisplaydata].html});
            this.setState({currentscreencolor: currentscreen[keydisplaydata].color});
            this.setState({currentscreenfont: currentscreen[keydisplaydata].font});
            this.setState({currentscreenbackground: currentscreen[keydisplaydata].background});
        }
        else if(currentscreen[keyscreentype] === 1) {
            this.setState({processingmodal: true})
            getGeneralSmartTableData( 'admin/interaction_sets/' + currentscreen[keyinteractionset] +  '/', text => this.handleInteractionSetloaded(text));
        }
    }



    public nextPage() {
        if(this.state.currentscreenidx < this.state.screens.length-1) {
            const newval = this.state.currentscreenidx + 1;
            this.setState({currentscreenidx: newval})
            setTimeout(this.loadScreenEditor, 100);
        }
    }

    public previousPage() {
        if(this.state.currentscreenidx > 0) {
            const newval = this.state.currentscreenidx - 1;
            this.setState({currentscreenidx: newval})
            setTimeout(this.loadScreenEditor, 100);
        }
    }

    public navbuttons (){
        if (this.state.screens.length > 1) {
            return (
                <Col xs="12" md="12" sm="12" lg="12">
                        <Button style={{marginRight: 9}} onClick={this.previousPage}>Prev</Button>

                        <Button style={{marginRight: 9}} onClick={this.nextPage}>Next</Button>

                        <p>Page {this.state.currentscreenidx + 1} of {this.state.screens.length}</p>
                    </Col>
              );
        }
        else{
            return (
                <div>
                    <p/>
                </div>

              );
        }
    }

    public draglist()  {

        return(
            <ReactDragList
                dataSource={this.state.screens}
                    rowKey="id"
                   // tslint:disable-next-line jsx-no-lambda
                    row = {(record, index) =>
                                                <div key={index} style={{ color: '#FFFF', backgroundColor: '#2DB7F5'  , border: 'none', margin: 13, padding: 9, width: '100%'}}>
                                                     <div className="simple-drag-row-title" style={{margin: 3}}>Screen title: {record[this.state.screenfields.title]}</div>
                                                        <span style={{margin: 3}}>Screen Type: {record[this.state.screenfields.type]}</span>
                                                    </div>
                                            }
                                            handles={true}
                                            className="simple-drag"
                                            rowClassName="simple-drag-row"
                                            onUpdate={this.handleOrderUpdate}
                                />
        );
    }

    public simpleGallery() {
        return (
            <Row>
                {this.state.images.map((image, index) =>
                    <Col  key={image.id} xs="4" sm="4" lg="4">
                    <div className="thumbnail">
                        <img src={image.src} width={image.thumbnailWidth}
                        height={image.thumbnailHeight} onClick={this.insertChosenImage.bind(this, image.src)}
                    />
                    <label>{image.caption}</label>
                    </div>
                </Col>)}
            </Row>
        )
    }

    public showEditor() {
        {/* tslint:disable-next-line no-string-literal */}
        const reval = this.state.screens.filter(e => e['id'] === this.state.contentscreenid).length > 0?
        "":
         <p>Load a screen to the right</p>
         return reval;
    }

    public screenTypeName(screentype) {
        if (screentype === 0) {
            return (
                <span>Content</span>
            )
        }
        else if (screentype === 1) {
            return (
                <span>Interaction</span>
            )
        }
        else if (screentype === 2) {
            return (
                <span>Video</span>
            )
        }
        else if (screentype === 3) {
            return (
                <span>Image</span>
            )
        }
        else{
            return (
                <span>Unknown</span>
            )
        }
    }
    public render() {
        if (this.state.tologin === true) {
           return <Redirect to='/login'/>
        }
        if (this.state.navigate === true) {
            return <Redirect to={this.state.destination}/>
        }


        const iconfields= {
            id: 'id',
            name: 'Title',
        }

        const behaviourfields= {
            id: 'id',
            name: 'Name',
        }


        const groupfields= {
            id: 'id',
            name: 'Title',
        }

        const assetfields= {
            id: 'id',
            name: 'Title',
        }

        const screensheaders = {
              'VideoUrl':  {
                filterable: false,
                invisible: false,
                sortable: false,
                text: 'Type Name',
                transform: (value, index, row) => (
                  <div>
                  {this.screenTypeName(row.ScreenType)}
                  </div>
                ),
              },
              'DisplayData':  {
                filterable: false,
                invisible: false,
                sortable: false,
                text: 'Actions',
                transform: (value, index, row) => (
                  <div style={{width: '450px'}}>
                  {/*tslint:disable-next-line jsx-no-lambda*/}
                  <Button onClick={() => this.handleDeleteClicked(row)} color="warning">
                      Delete
                  </Button>
              </div>
                ),
              },
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },

        }

        const behaviourfeedbackheaders = {
            UpdatedDateTime: {
                filterable: false,
                sortable: false,
                text: 'Actions',
                transform: (value, idx) => (
                  <div>
                  <i
                    className="fa fa-edit"
                    style={{ cursor: 'pointer', margin: 6 }}
                    // onClick={this.handleDeleteClicked.bind(this, idx)}
                    // onKeyDown={e => this.handleDelete(e, idx)}
                    role='button'
                  />
                  </div>
                ),
              },
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },

        }

        const questionheaders = {
            UpdatedDateTime: {
                filterable: false,
                sortable: false,
                text: 'Actions',
                transform: (value, idx) => (
                  <div>
                  <i
                    className="fa fa-plus-square"
                    style={{ cursor: 'pointer', margin: 6 }}
                    onClick={this.handleDeleteClicked.bind(this, idx)}
                    // onKeyDown={e => this.handleDelete(this, idx)}
                    role='button'
                  />
                  <i
                    className="fa fa-folder-open"
                    style={{ cursor: 'pointer' , margin: 6}}
                    onClick={this.handleEditAnswerClicked.bind(this, idx)}
                    // onKeyDown={this.handleEditAnswerClicked.bind(this, idx)}
                    role='button'
                  />
                  </div>
                ),
              },
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },

        }

        const behaviourheaders = {
            UpdatedDateTime: {
                filterable: false,
                sortable: false,
                text: 'Actions',
                transform: (value, idx) => (
                  <div>
                  <i
                    className="fa fa-edit"
                    style={{ cursor: 'pointer', margin: 6 }}
                    // onClick={this.handleDeleteClicked.bind(this, idx)}
                    // onKeyDown={e => this.handleDelete(e, idx)}
                    role='button'
                  />
                  </div>
                ),
              },
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },

        }

        const adminHomeStyles = {
            welcometext: {
                margin: 3,
                marginLeft: 13,
                marginTop: '2%'
            },

            modal:{
                width: '300px',
            },

            tabrow: {
                margin: 1,
                marginTop: '2%',
              },

            tabcontent: {
                margin: 1,
                marginTop: '2%'
            },

            tableHeaderButton: {
                margin: 2,
                marginLeft: 8,
            },

            widgetrow: {
              margin: 3,
              marginTop: '2%'
            },

            navitem: {
                margin: 3,
                padding: 5,
              },
        }


        return (
            <div>

              <NavBar logoutParent={this.onLogout}/>

              <ToastContainer style={{zIndex: 9999999}} />

              <Breadcrumb>
                  <BreadcrumbItem><a onClick={this.openWidget.bind(this, 'home')}>Home</a></BreadcrumbItem>
                  <BreadcrumbItem active={false}>SingleLesson</BreadcrumbItem>
                  <BreadcrumbItem active={true}>{this.state.lessoninfo.Name}</BreadcrumbItem>
                </Breadcrumb>

              <div className="animated fadeIn">

                <Row style={adminHomeStyles.tabrow}>
                <Col xs="12" md="12" className="mb-4">
                    <Nav tabs={true} style={{flexWrap: 'nowrap'}}>
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink  onClick={this.setTab.bind(this, '1')}>
                                Screens
                            </NavLink>
                        </NavItem>
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink  onClick={this.setTab.bind(this, '2')}>
                                Order
                            </NavLink>
                        </NavItem>
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink  onClick={this.setTab.bind(this, '5')}>
                                Editor
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <div>
                    <Modal isOpen={this.state.contentcreatemodal} toggle={this.contentcreatetoggle} className="">
                            <ModalHeader toggle={this.contentcreatetoggle}>Create Content Screen</ModalHeader>
                            <ModalBody>
                                <form onSubmit={this.contentcreateSubmit}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="order">Display Order</Label>
                                                <Input type="select" id="order" name="order" placeholder="order" required={true} >
                                                    <option value="0">0</option>
                                                    {this.state.screens.map((d, i) => <option key={d[this.state.screenfields.id]} value={i + 1}>  {i +1}</option>)}
                                                </Input>
                                                <Label className="frm-modal-label" htmlFor="order">Title</Label>
                                                <Input type="text" id="title" name="title" placeholder="Title" required={true} />

                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button  type="submit" color="primary" className="adminmodalbutton">Submit</Button>
                                        <Button  onClick={this.contentcreatetoggle} color="secondary" className="adminmodalbutton">Cancel</Button>
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>

                        <Modal isOpen={this.state.codecontentcreatemodal} toggle={this.codecontentcreatetoggle} className="">
                            <ModalHeader toggle={this.codecontentcreatetoggle}>Create Content Screen</ModalHeader>
                            <ModalBody>
                                <form onSubmit={this.codecontentcreateSubmit}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="order">Display Order</Label>
                                                <Input type="select" id="order" name="order" placeholder="order" required={true} >
                                                    <option value="0">0</option>
                                                    {this.state.screens.map((d, i) => <option key={d[this.state.screenfields.id]} value={i + 1}>  {i +1}</option>)}
                                                </Input>
                                                <Label className="frm-modal-label" htmlFor="order">Title</Label>
                                                <Input type="text" id="title" name="title" placeholder="Title" required={true} />
                                                <br/><br/>
                                                <input id="code" type="file" name="code" accept=".html" multiple={false} required={true}/>


                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button  type="submit" color="primary" className="adminmodalbutton">Submit</Button>
                                        <Button  onClick={this.codecontentcreatetoggle} color="secondary" className="adminmodalbutton">Cancel</Button>
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>

                        <Modal isOpen={this.state.contentpreviewmodal} toggle={this.contentpreviewtoggle}>
                            <ModalHeader toggle={this.contentpreviewtoggle}>Screen Preview</ModalHeader>

                            <ModalBody>
                                <p>hj</p>
                            </ModalBody>
                        </Modal>
                        <Modal isOpen={this.state.imageimportmodal} toggle={this.imageimporttoggle}>
                            <ModalHeader toggle={this.imageimporttoggle}>Image import</ModalHeader>
                            <ModalBody>
                                <Row>
                                    <p>Image Gallery</p>

                                    <Scrollbars  style={{ paddingTop: "2em", height: "33em" }}>
                                        {this.simpleGallery()}
                                    </Scrollbars>

                                </Row>
                            </ModalBody>
                        </Modal>



                        <Modal style={adminHomeStyles.modal} isOpen={this.state.videocreatemodal} toggle={this.videocreatetoggle} className="">
                            <ModalHeader toggle={this.videocreatetoggle}>Create Video screen</ModalHeader>
                            <ModalBody>
                            <form onSubmit={this.videocreateSubmit}>
                                    <Row>

                                        <Col>
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="order">Display Order</Label>
                                                <Input type="select" id="order" name="order" placeholder="order" required={true} >
                                                    <option value="0">0</option>
                                                    {this.state.screens.map((d, i) => <option key={d[this.state.screenfields.id]} value={i + 1}>  {i +1}</option>)}
                                                </Input>
                                                <Label className="frm-modal-label" htmlFor="order">Title</Label>
                                                <Input type="text" id="title" name="title" placeholder="Title" required={true} />
                                            </FormGroup>
                                        </Col>

                                        <Col lg="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="video">Video</Label>
                                                <Input type="select" id="video" name="video" placeholder="video" required={true} >
                                                    {this.state.assets.map(d => <option key={d[this.state.assetfields.filename]} value={d[this.state.assetfields.filename]}> {d[this.state.assetfields.title]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button color="primary"  type="submit" className="adminmodalbutton">Submit</Button>
                                        <Button  onClick={this.videocreatetoggle} className="adminmodalbutton">Cancel</Button>
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>

                        <Modal style={adminHomeStyles.modal} isOpen={this.state.interactionmodal} toggle={this.interactiontoggle} className="">
                            <ModalHeader toggle={this.videocreatetoggle}>Create Interaction screen</ModalHeader>
                            <ModalBody>
                            <form onSubmit={this.InteractioncreateSubmit}>
                                    <Row>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="order">Display Order</Label>
                                                <Input type="select" id="order" name="order" placeholder="order" required={true} >
                                                    <option value="0">0</option>
                                                    {this.state.screens.map((d, i) => <option key={d[this.state.screenfields.id]} value={i + 1}>  {i +1}</option>)}
                                                </Input>
                                                <Label className="frm-modal-label" htmlFor="order">Title</Label>
                                                <Input type="text" id="title" name="title" placeholder="Title" required={true} />
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="video" >Interaction Set</Label>
                                                <Input type="select" id="interactionset" name="interactionset" placeholder="interactionset" required={true} >
                                                    {this.state.interactionsets.map(d => <option key={d[this.state.interactionfields.title]} value={d[this.state.interactionfields.id]}> {d[this.state.interactionfields.title]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button color="primary"  type="submit" className="adminmodalbutton">Submit</Button>
                                        <Button  onClick={this.interactiontoggle} className="adminmodalbutton">Cancel</Button>
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>
                    </div>
                    <TabContent activeTab={this.state.activeTab} style={adminHomeStyles.tabcontent}>
                        <TabPane tabId="1">
                            <Card className="admincard">
                                <CardHeader>
                                    <h5> Screens</h5>

                                    <Button color="primary" onClick={this.contentcreatetoggle}>Add Content</Button>
                                    <Button disabled={false} color="primary" onClick={this.interactiontoggle}>Add Interaction</Button>
                                    <Button color="primary" onClick={this.videocreatetoggle}>Add Video</Button>
                                    <Button color="primary" onClick={this.gotoPreview}>Preview</Button>
                                </CardHeader>
                                <CardBody>

                                    <Loader loaded={this.state.loaded}>

                                        <SmartDataTable
                                            data={this.state.screens}
                                            headers={screensheaders}
                                            name='Screens'
                                            perPage={10}
                                            className='ui compact selectable table admintable'
                                            sortable={false}
                                        />
                                    </Loader>
                                </CardBody>
                            </Card>

                        </TabPane>

                        <TabPane tabId="2">
                            <Card className="admincard">
                                <CardHeader>
                                    <h5> Order</h5>
                                </CardHeader>
                                <CardBody>

                                    <Loader loaded={this.state.loaded}>
                                        {this.draglist()}
                                    </Loader>
                                    <Button style={{marginLeft: '3%', borderRadius: '15px', marginBottom: '14%', marginTop: '5%', width: '13em'}} onClick={this.orderSubmit}>Change Order</Button>
                                </CardBody>
                            </Card>
                            </TabPane>
                            <TabPane tabId="3">
                                <SimpleLoader loaded={!this.state.processingmodal}/>

                            </TabPane>

                            <TabPane tabId="4">
                                <SimpleLoader loaded={!this.state.processingmodal}/>

                                <h3>Background</h3>

                                <TwitterPicker
                                    color={ this.state.currentscreenbackground }
                                    onChangeComplete={ this.handleBackgroundChange }
                                />
                            </TabPane>

                            <TabPane tabId="5">
                                <SimpleLoader loaded={!this.state.processingmodal}/>

                                <div style={{backgroundColor: 'white', padding: '2%', paddingTop: '5%'}}>
                                <Row>
                                    <Col xs="12" lg="10">
                                        {/* tslint:disable-next-line no-string-literal */}
                                        {this.state.screens.filter(e => e['ScreenType'] === 'Content').length > 0?
                                        <div>
                                            {this.state.contentscreenid ===0?
                                                <p>Open a screen on the right to start editing</p>:

                                                    this.showEditor()

                                                    }
                                        </div>

                                        : <p>No content Screens Available</p>}
                                    </Col>
                                    <Col xs="12" lg="2">
                                        <h5>Content Overview</h5>
                                        <ul style={{listStyle: 'none'}}>
                                        {/* tslint:disable-next-line no-string-literal */}
                                            {this.state.screens.filter(e => e['ScreenType'] === 'Content').map(d =>

                                              /*tslint:disable-next-line jsx-no-lambda*/
                                              <li key={d.id} onClick={() => this.setScreenId(d)}>

                                              <Row style={{backgroundColor: d.id===this.state.contentscreenid?'#3ee9f7':'transparent', 'margin': '3px', padding: '3px', paddingTop: '13px'}}>
                                                  <Col lg="4">
                                                    <img src="http://media.mypl.life/assets/greenarrow.svg" width="25"/>
                                                  </Col>
                                                  <Col lg="8">
                                                    <p style={{fontSize: '11px'}}>{d.Title}</p>
                                                  </Col>
                                              </Row>
                                              </li>)
                                            }
                                        </ul>
                                    </Col>
                                </Row>
                                </div>
                            </TabPane>
                    </TabContent>
                </Col>
          </Row>
              </div>

            </div>
        )
    }
}

export default LessonScreenPage;


// WEBPACK FOOTER //
// ./src/pages/SingleLesson/lessonScreenPage.Component.tsx